module.exports = __webpack_public_path__ + "static/media/markdown.8943aa59.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/markdown.png
// module id = 1498
// module chunks = 0